import NewCalenderService from '../../service/new-calender';
import moment from "moment";

const Action = {
    FETCH_EVENTS_MONTHLY: '[NEW CALENDAR APP] FETCH EVENTS MONTHLY',
    FETCH_EVENTS_DAILY: '[NEW CALENDAR APP] FETCH EVENTS DAILY',
    SET_CALENDAR_DATE: '[NEW CALENDAR APP] SET CALENDAR DATE',
    EXPORT_CALENDAR: '[NEW CALENDAR APP] EXPORT CALENDAR'
};

const ActionCreator = {
    fetchEventsMonthly({year, month}) {
        return async dispatch => {
            const events = await NewCalenderService.fetchEventsMonthly({year, month});
            dispatch({type: Action.FETCH_EVENTS_MONTHLY, payload: events});
            return events;
        };
    },
    fetchEventsDaily({year, month, date}) {
        return async dispatch => {
            const events = await NewCalenderService.fetchEventsDaily({year, month, date});
            dispatch({type: Action.FETCH_EVENTS_DAILY, payload: events});
            return events;
        };
    },
    setCalendarDate({year, month}) {
        return async dispatch => dispatch({type: Action.SET_CALENDAR_DATE, payload: {date: {year, month}}});
    },
    exportCalendar({dateFrom, dateTo}) {
        return async dispatch => {
            const events = await NewCalenderService.exportCalendar({dateFrom, dateTo});
            dispatch({type: Action.EXPORT_CALENDAR, payload: events});
            return events
        }
    },
};

const today = moment();

const initialState = {
    date: {
        year: today.year(),
        month: today.month(),
    },
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.SET_CALENDAR_DATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/new-calendar.js